// extracted by mini-css-extract-plugin
export default {"container":"AddPopUpBody_container__iA0ob","profileInitial":"AddPopUpBody_profileInitial__40X8U","users":"AddPopUpBody_users__HD7h8"};